import { SearchOptionsProps } from "@/types/faq";
import React from "react";

export const SearchOptions = ( props: SearchOptionsProps ) => {
  return (
    <div className="uk-margin-top">
      <div className="faq-search-sub-title">
        <p className="uk-text-default uk-text-bold">検索オプション</p>
      </div>
      <div className="uk-flex uk-flex-middle uk-margin-left uk-margin-top">
        <p className="uk-text-default uk-flex-start uk-text-bold min-width-52">情報区分</p>
        <div className="uk-flex uk-flex-wrap">
          {props.faq_type_list?.map(( type, index ) => (
            <label
              key={index}
              className={'width-160 uk-margin-small-left'}
            >
              <input
                type="checkbox"
                onChange={() => props.onClickCheckType(type.id)}
                checked={props.checkTypeIds.includes(type.id)}
              />
              {type.name}
            </label>
          ))}
        </div>
      </div>
      <div className="uk-flex uk-flex-middle uk-margin-left uk-margin-small-top">
        <p className="uk-text-default uk-flex-start uk-text-bold min-width-52">情報種別</p>
        <div className="uk-flex uk-flex-wrap">
          {props.faq_kind_list?.map(( kind, index ) => (
            <label
              key={index}
              className={'width-160 uk-margin-small-left'}>
              <input
                type="checkbox"
                onChange={() => props.onClickCheckKind(kind.id)}
                checked={props.checkKindIds.includes(kind.id)}/>
              {kind.name}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};